import { spacingNumeric } from './spacing.js';

/**
 * CSS variables used by the Grid component in the react package.
 */
const gridStyleVariables = {
  margin: "--iz-grid-margin",
  gutter: "--iz-grid-gutter",
  columns: "--iz-grid-columns"
};
const VERTICAL_NAV_WIDTH = 240;

/**
 * The maximum width of the Grid component in the react package,
 * including "margins" (actually padding) on both sides.
 *
 * Takes the vertical-nav width into account.
 */
const maxGridWidth = 1676 - VERTICAL_NAV_WIDTH;

/**
 * Breakpoints used by the Grid component in the react package.
 *
 * **xs**: 0px -> 519px,
 * 4 columns, 16 gutter, 16 margins
 *
 * **s**: 520px -> 735px,
 * 6 columns, 16 gutter, 16 -> 32 margins
 *
 * **m**: 736px -> 1087px,
 * 8 columns, 32 gutter, 32 -> 48 margins
 *
 * **l**: 1120px -> 1676px,
 * 12 columns, 32 gutter, 48 -> 64 margins
 * */
const breakpoints = {
  /**
   * 0px -> 519px
   *
   * 4 columns, 16 gutter, 16 margins
   * */
  xs: 0,
  /**
   * 520px -> 735px
   *
   * 6 columns, 16 gutter, 16 -> 32 margins
   * */
  s: 520,
  /**
   * 736px -> 1087px
   *
   * 8 columns, 32 gutter, 32 -> 48 margins
   * */
  m: 736,
  /**
   * 1120px -> 1676px (including vertical navigation)
   *
   * 12 columns, 32 gutter, 48 -> 64 margins
   * */
  l: 1120
};
/**
 * For each size after xs, we add an additional breakpoint as the margins grow
 * by a combined 32pxs (16px per side). This maintains a more consistent column width.
 *
 * The l2 breakpoint only kicks in after the vertical navigation has entered.
 */
const additionalGridBreakpoints = {
  s2: breakpoints.s + spacingNumeric.small,
  m2: breakpoints.m + spacingNumeric.small,
  l2: breakpoints.l + VERTICAL_NAV_WIDTH + spacingNumeric.small
};
const gridConfig = {
  xs: {
    columns: 4,
    gutter: spacingNumeric.small,
    margin: spacingNumeric.small,
    breakpoint: breakpoints.xs
  },
  s: {
    columns: 6,
    gutter: spacingNumeric.small,
    margin: spacingNumeric.small,
    breakpoint: breakpoints.s
  },
  s2: {
    columns: 6,
    gutter: spacingNumeric.small,
    margin: spacingNumeric.small + spacingNumeric.small,
    breakpoint: additionalGridBreakpoints.s2
  },
  m: {
    columns: 8,
    gutter: spacingNumeric.large,
    margin: spacingNumeric.large,
    breakpoint: breakpoints.m
  },
  m2: {
    columns: 8,
    gutter: spacingNumeric.large,
    margin: spacingNumeric.large + spacingNumeric.small,
    breakpoint: additionalGridBreakpoints.m2
  },
  l: {
    columns: 12,
    gutter: spacingNumeric.large,
    margin: spacingNumeric.xLarge,
    breakpoint: breakpoints.l
  },
  l2: {
    columns: 12,
    gutter: spacingNumeric.large,
    margin: spacingNumeric.xLarge + spacingNumeric.small,
    breakpoint: additionalGridBreakpoints.l2
  }
};

export { breakpoints, gridConfig, gridStyleVariables, maxGridWidth };
//# sourceMappingURL=grid.js.map
